import React from 'react';
import Button from '../../../components/Common/Button';
import { StyledLoading } from './LoadingButton.style';

const DEFAULT_FONT_SIZE = '16px';

const LoadingButton = function LoadingButton({ style = {} }) {
  const fontSize = style.body?.fontSize || DEFAULT_FONT_SIZE;
  const backgroundColor = style.inactive?.backgroundColor || 'initial';
  const buttonStyle = { ...style.button, ...{ fontSize, backgroundColor } };

  return (
    <Button styled={buttonStyle} disabled submit>
      <StyledLoading size={fontSize} />
    </Button>
  );
};

export default LoadingButton;
